export class TimeRegistration {
  constructor(
    public readonly id: string,
    public readonly employeeId: string,
    public readonly date: Date,
    public readonly hours: number,
    public readonly remark: string|null,
    public readonly workorderId: string|null,
  ) {
  }

  static fromJson(json: any): TimeRegistration {
    return new TimeRegistration(
      json['id'],
      json['user_sub'],
      new Date(json['date']),
      json['hours'],
      json['remark'],
      json['workorder_id'],
    )
  }
}
